<template>
  <div class="article-highlight-carousel lazyload">
    <carousel
      :swipe-on-desktop="swipeOnDesktop"
      :speed="600"
      :vertical="true"
      :navigation-enabled="true"
      :pagination-enabled="false"
      :per-page="1"
      :carousel-identifier="carouselIdentifier"
      class="article-highlight-carousel__content-carousel"
    >
      <slide
        v-for="(article, articleIndex) in articlesList"
        :key="articleIndex"
        class="article-highlight__content-slide"
      >
        <div class="article-highlight__slide-inner">
          <div class="article-container">
            <img
              v-if="article.image"
              loading="lazy"
              :src="article.image.Src"
              :alt="article.image.Alt"
              class="article-image"
              @click="redirectToArticle(article.url)"
            />
            <h2 class="article-subtopic-title">{{ article.subtopictitle }}</h2>
          </div>
          <h3 class="article-title-name" @click="redirectToArticle(article.url)">
            {{ article.articletitle }}
          </h3>
        </div>
      </slide>
    </carousel>
  </div>
</template>
<script>
export default {
  name: 'article-highlight-slider',
  props: {
    topicData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      carouselIdentifier: `carousel-${Date.now()}`,
    };
  },
  computed: {
    // set maximum items to visible in ui
    articlesList() {
      const articles = this.topicData.article_sliders;
      const maxItem = this.topicData.maximumslider;
      if (articles.length > maxItem) {
        return articles.slice(0, maxItem);
      } else {
        return articles;
      }
    },
  },
  methods: {
    redirectToArticle(url) {
      window.location.href = url;
    },
  },
};
</script>
